export default "__VITE_ASSET__t6cl7$yW__"